module.exports = __webpack_public_path__ + "static/media/user-icon.56902ef6.svg";